import { render, staticRenderFns } from "./IndexHero.vue?vue&type=template&id=5237505d"
import script from "./IndexHero.vue?vue&type=script&lang=js"
export * from "./IndexHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports